import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const i = s((o, e) => /* @__PURE__ */ a.jsx(
  l,
  {
    ref: e,
    ...o,
    image: (r) => /* @__PURE__ */ a.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: /* @__PURE__ */ a.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M6 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H6zM4 4V3a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.153l-1.36 8.164A1 1 0 0 1 11.5 16h-7a1 1 0 0 1-.986-.836L2.153 7H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
i.displayName = "TrashIcon";
export {
  i as TrashIcon,
  i as default
};
//# sourceMappingURL=index.js.map
